export const CODE_RESEND_DELAY_MS = 10000;

export const SMS_CODE_LENGTH = 6;
